"use client";
import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {getSectionSpace, SpaceProps} from "@/sections/use-section-space";

import {TeamCard, type TeamMember} from "@/entities/team/ui/card/team-section-card";

// import { TeamMember } from "@/entities/team/types";

import {Typography} from "@/shared/ui/data-display/typography";
import {ContainerBase} from "@/shared/ui/layout/container-base";
import {assetPath} from "@/shared/utils/asset-path";

import "@/sections/meet-the-team/team-section/team-section.scss";

export interface TeamSectionProps {
    title: string;
    members: Array<TeamMember>;
    space?: SpaceProps;
    anchorId?: string;
}

export function TeamSection({title, members, space, anchorId}: TeamSectionProps): JSX.Element {
    const sectionVars = getSectionSpace(space);
    return (
        <section className="team-section" style={sectionVars} id={anchorId}>
            <SmartImage
                className="team-section__decor-arrow"
                src={assetPath("/images/team-section/decor-left.svg")}
                alt=""
                width={500}
                height={500}
                aria-hidden="true"
            />
            <SmartImage
                className="team-section__decor-right"
                src={assetPath("/images/team-section/decor-right.svg")}
                alt=""
                width={500}
                height={500}
                aria-hidden="true"
            />
            <SmartImage
                className="team-section__decor-left"
                src={assetPath("/images/team-section/decor-bottom-left.svg")}
                alt=""
                width={500}
                height={500}
                aria-hidden="true"
            />
            <ContainerBase>
                <div className="team-section__header">
                    <Typography as="h2" size={{desktop: 40, mobile: 20}} weight={500} className="team-section__title">
                        {title}
                    </Typography>
                </div>

                <div className="team-section__grid">
                    {members.map((m, index) => (
                        <TeamCard key={index} {...m} />
                    ))}
                </div>
            </ContainerBase>
        </section>
    );
}
